var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("passwordChangeByLink.title")))]),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: { submit: _vm.save },
          model: {
            value: _vm.isValid,
            callback: function($$v) {
              _vm.isValid = $$v
            },
            expression: "isValid"
          }
        },
        [
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("passwordChangeByLink.company"),
              readonly: ""
            },
            model: {
              value: _vm.company,
              callback: function($$v) {
                _vm.company = $$v
              },
              expression: "company"
            }
          }),
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("passwordChangeByLink.alias"),
              readonly: ""
            },
            model: {
              value: _vm.alias,
              callback: function($$v) {
                _vm.alias = $$v
              },
              expression: "alias"
            }
          }),
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("passwordChangeByLink.login"),
              readonly: ""
            },
            model: {
              value: _vm.login,
              callback: function($$v) {
                _vm.login = $$v
              },
              expression: "login"
            }
          }),
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("passwordChangeByLink.password") + "*",
              rules: _vm.rules.passwordRules,
              type: "password"
            },
            model: {
              value: _vm.password,
              callback: function($$v) {
                _vm.password = $$v
              },
              expression: "password"
            }
          }),
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("passwordChangeByLink.repeatPassword") + "*",
              rules: _vm.rules.repeatPasswordRules,
              type: "password"
            },
            model: {
              value: _vm.passwordRepeat,
              callback: function($$v) {
                _vm.passwordRepeat = $$v
              },
              expression: "passwordRepeat"
            }
          }),
          _c(
            "v-btn",
            {
              attrs: {
                disabled: !_vm.isValid || _vm.$store.getters["Ajax/loading"],
                color: "success"
              },
              on: { click: _vm.save }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("passwordChangeByLink.changePasswordButton"))
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }